module.exports = __webpack_public_path__ + "static/media/casumo_logo.458b43b8.png";